var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90217"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(0 1 1 0 -290.99 -168.882)",
    gradientUnits: "userSpaceOnUse",
    x1: 489.505,
    x2: 624.909,
    xlinkHref: "#lg1",
    y1: 497.71,
    y2: 497.71
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(0 1 1 0 -290.99 -168.882)",
    gradientUnits: "userSpaceOnUse",
    x1: 629.647,
    x2: 444.228,
    xlinkHref: "#lg1",
    y1: 497.71,
    y2: 497.71
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(0 1 1 0 -290.99 -168.882)",
    gradientUnits: "userSpaceOnUse",
    x1: 633.772,
    x2: 547.644,
    y1: 436.649,
    y2: 350.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f90217",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2669,
    stopColor: "#e7010f",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#ce0004",
    stopOpacity: 0.723
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbd0e4"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(0 1 1 0 -290.99 -168.882)",
    gradientUnits: "userSpaceOnUse",
    x1: 536.611,
    x2: 578.281,
    xlinkHref: "#lg2",
    y1: 339.488,
    y2: 381.158
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(0 -1 -1 0 -1011.765 1247.145)",
    gradientUnits: "userSpaceOnUse",
    x1: 846.971,
    x2: 870.945,
    xlinkHref: "#lg2",
    y1: -1092.708,
    y2: -1068.735
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2b631"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-.599 .801 .801 .599 180.584 -421.664)",
    gradientUnits: "userSpaceOnUse",
    x1: 482.246,
    x2: 617.65,
    xlinkHref: "#lg3",
    y1: 478.165,
    y2: 478.165
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-.599 .801 .801 .599 180.584 -421.664)",
    gradientUnits: "userSpaceOnUse",
    x1: 622.388,
    x2: 436.969,
    xlinkHref: "#lg3",
    y1: 478.165,
    y2: 478.165
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.051,
    x2: 56.718,
    y1: 307.749,
    y2: 155.417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a126",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec4437"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-.599 .801 .801 .599 180.584 -421.664)",
    gradientUnits: "userSpaceOnUse",
    x1: 529.352,
    x2: 571.022,
    xlinkHref: "#lg2",
    y1: 319.943,
    y2: 361.613
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.599 -.801 -.801 -.599 -1244.461 281.115)",
    gradientUnits: "userSpaceOnUse",
    x1: 854.23,
    x2: 878.204,
    xlinkHref: "#lg2",
    y1: -1073.163,
    y2: -1049.19
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28a265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28895e"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(-.959 .283 .283 .959 709.648 -341.845)",
    gradientUnits: "userSpaceOnUse",
    x1: 488.132,
    x2: 623.535,
    xlinkHref: "#lg4",
    y1: 458.164,
    y2: 458.164
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-.959 .283 .283 .959 709.648 -341.845)",
    gradientUnits: "userSpaceOnUse",
    x1: 628.274,
    x2: 442.855,
    xlinkHref: "#lg4",
    y1: 458.164,
    y2: 458.164
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.415,
    x2: 239.911,
    y1: 199.272,
    y2: 95.768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#108372",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006837"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-.959 .283 .283 .959 709.648 -341.845)",
    gradientUnits: "userSpaceOnUse",
    x1: 535.238,
    x2: 576.908,
    xlinkHref: "#lg2",
    y1: 299.941,
    y2: 341.611
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(.959 -.283 -.283 -.959 -852.551 -631.993)",
    gradientUnits: "userSpaceOnUse",
    x1: 848.345,
    x2: 872.318,
    xlinkHref: "#lg2",
    y1: -1053.162,
    y2: -1029.188
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7faef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c8df1"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-.938 -.347 -.347 .938 1085.655 38.81)",
    gradientUnits: "userSpaceOnUse",
    x1: 504.82,
    x2: 640.224,
    xlinkHref: "#lg5",
    y1: 445.665,
    y2: 445.665
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(-.938 -.347 -.347 .938 1085.655 38.81)",
    gradientUnits: "userSpaceOnUse",
    x1: 644.962,
    x2: 459.543,
    xlinkHref: "#lg5",
    y1: 445.665,
    y2: 445.665
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4256ac",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1464"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 490.149,
    x2: 412.21,
    xlinkHref: "#lg6",
    y1: 176.495,
    y2: 102.268
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(-.938 -.347 -.347 .938 1085.655 38.81)",
    gradientUnits: "userSpaceOnUse",
    x1: 551.926,
    x2: 593.596,
    xlinkHref: "#lg2",
    y1: 287.443,
    y2: 329.113
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(.938 .347 .347 -.938 7.999 -1128.797)",
    gradientUnits: "userSpaceOnUse",
    x1: 831.656,
    x2: 855.63,
    xlinkHref: "#lg2",
    y1: -1040.663,
    y2: -1016.69
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.346,
    x2: 325.011,
    xlinkHref: "#lg6",
    y1: 437.663,
    y2: 362.328
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(-.938 -.347 -.347 .938 1085.655 38.81)",
    gradientUnits: "userSpaceOnUse",
    x1: 551.926,
    x2: 593.596,
    xlinkHref: "#lg2",
    y1: 560.082,
    y2: 601.752
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(.938 .347 .347 -.938 7.999 -1128.797)",
    gradientUnits: "userSpaceOnUse",
    x1: 831.656,
    x2: 855.63,
    xlinkHref: "#lg2",
    y1: -1313.302,
    y2: -1289.329
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m413.441 388.324c0-37.391-30.311-67.702-67.702-67.702h-278.037c-37.391.001-67.702 30.312-67.702 67.702 0 37.391 30.311 67.702 67.702 67.702h278.037c37.391 0 67.702-30.311 67.702-67.702z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.1 388.324c0-19.499-15.863-35.361-35.361-35.361h-278.037c-19.499 0-35.361 15.863-35.361 35.361s15.863 35.361 35.361 35.361h278.037c19.499.001 35.361-15.862 35.361-35.361z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m22.399 388.324c0-26.384 20.31-46.695 46.694-46.695 14.104 0 26.776 5.037 35.521 14.756l99.64 99.64h-134.918l-32.181-32.181c-9.719-8.743-14.756-21.416-14.756-35.52z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 69.094,
    cy: 388.324,
    fill: "url(#SVGID_4_)",
    r: 47.773
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.094,
    cy: 388.324,
    fill: "url(#SVGID_5_)",
    r: 27.485
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m399.969 428.853c22.384-29.951 16.249-72.376-13.701-94.759l-222.713-166.444c-29.951-22.384-72.376-16.249-94.759 13.701-22.384 29.951-16.249 72.376 13.701 94.759l222.713 166.445c29.951 22.383 72.376 16.249 94.759-13.702z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.064 409.493c11.673-15.619 8.462-37.821-7.156-49.494l-222.713-166.444c-15.619-11.673-37.821-8.462-49.494 7.156s-8.462 37.821 7.156 49.494l222.713 166.445c15.619 11.672 37.822 8.462 49.494-7.157z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m398.916 430.191-246.176-245.745c-21.134-15.795-47.607-8.76-63.401 12.375-15.196 20.334-15.221 46.103 3.883 62.299l98.972 98.972 113.017 84.463c29.493 22.042 71.069 16.412 93.705-12.364z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.141,
    cy: 222.714,
    fill: "url(#SVGID_9_)",
    r: 47.773
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.141,
    cy: 222.714,
    fill: "url(#SVGID_10_)",
    r: 27.485
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m364.916 453.253c35.859-10.591 56.343-48.247 45.752-84.106l-78.757-266.65c-10.591-35.859-48.247-56.343-84.106-45.752-35.859 10.591-56.343 48.247-45.752 84.106l78.757 266.65c10.591 35.86 48.247 56.344 84.106 45.752z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.756 422.238c18.7-5.523 29.42-25.23 23.896-43.93l-78.757-266.65c-5.523-18.7-25.23-29.42-43.93-23.896s-29.42 25.23-23.896 43.93l78.757 266.65c5.523 18.699 25.23 29.419 43.93 23.896z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.447 98.909c-15.196 20.334-15.221 46.103 3.883 62.299l157.415 157.415-56.279-190.544-41.618-41.544c-21.134-15.795-47.606-8.76-63.401 12.374z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 267.376,
    cy: 123.01,
    fill: "url(#SVGID_14_)",
    r: 47.773
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.376,
    cy: 123.01,
    fill: "url(#SVGID_15_)",
    r: 27.485
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m322.231 451.814c35.064 12.983 74.014-4.918 86.997-39.982l96.541-260.739c12.983-35.064-4.918-74.014-39.982-86.997-35.064-12.983-74.014 4.918-86.997 39.982l-96.541 260.739c-12.982 35.064 4.918 74.014 39.982 86.997z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.461 421.486c18.285 6.77 38.669-2.598 45.439-20.883l96.541-260.739c6.77-18.285-2.598-38.669-20.883-45.439s-38.669 2.598-45.439 20.883l-96.541 260.739c-6.771 18.285 2.597 38.668 20.883 45.439z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m509.941 129.905-38.849-38.781c-21.134-15.795-47.607-8.76-63.402 12.375-15.196 20.334-15.221 46.103 3.883 62.299l64.77 64.77 29.426-79.475c2.588-6.987 3.929-14.128 4.172-21.188z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.796,
    cy: 128.891,
    fill: "url(#SVGID_19_)",
    r: 47.773
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.796,
    cy: 128.891,
    fill: "url(#SVGID_20_)",
    r: 27.485
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m381.432 351.566c-4.258-4.25-9.315-7.683-14.978-9.714-18.573-6.659-38.871 1.18-51.901 18.616-15.196 20.334-15.221 46.103 3.883 62.299l33.021 33.021c25.32-2.163 48.365-18.547 57.773-43.956l8.789-23.737z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.13,
    cy: 384.567,
    fill: "url(#SVGID_22_)",
    r: 47.773
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.13,
    cy: 384.567,
    fill: "url(#SVGID_23_)",
    r: 27.485
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScript);
export default __webpack_public_path__ + "static/media/icon-script.5a89935c446ab1dc480b4d382b91c0d1.svg";
export { ForwardRef as ReactComponent };